import { Injectable } from '@angular/core';
import { marked, Tokens } from 'marked';
import { RequestDto } from 'src/portal/ai-proxy-api/models/request-dto';
import { RoleEnum } from 'src/portal/ai-proxy-api/models/role-enum';
import { ProxyService } from 'src/portal/ai-proxy-api/services/proxy.service';
import { INSTRUCTIONS } from './instructions.constants';


export interface ChatMessage {
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
  isTyping?: boolean;
  companies?: CompanyDomain[];
}

export interface CompanyDomain {
  company_name: string;
  domain: string;
}

export enum ChatCommand {
  FindEmployees = 'Find profiles of employees',
  FindCustomers = 'Find customers of products',
  AnalyzeTechStacks = 'Analyze tech stacks for company',
  RecommendSoftware = 'Recommend software',
  BenchmarkCompanies = 'Benchmark companies',
  GeneralMode = 'General Mode',
  ProductAnalysis = 'Product Analysis',
}

interface CompanyDomainsData {
  company_domains?: unknown;
  [key: string]: unknown;
}

interface ModelConfig {
  systemInstruction: string;
  temperature?: number;
  tools?: object[];
  thinkingConfig?: object;
}

@Injectable({
  providedIn: 'root'
})
export class AiChatProxyService {

  constructor(public proxyService:ProxyService) {
    this.setupMarkedRenderer();
  }

  public async sendMessage(message: string, command: ChatCommand): Promise<void> {
    let systemInstruction = '';
    switch (command) {
      case ChatCommand.FindEmployees:
        systemInstruction = INSTRUCTIONS.systemIstructionEmployee;
        break;
      case ChatCommand.FindCustomers:
        systemInstruction: INSTRUCTIONS.systemInstructionCompaniesUseProduct;
        break;
      case ChatCommand.AnalyzeTechStacks:
        systemInstruction = INSTRUCTIONS.systemInstructionCompanySoftwareAnalysis;
        break;
      case ChatCommand.ProductAnalysis:
        systemInstruction = INSTRUCTIONS.systemInstructionProduct;
        break;
      case ChatCommand.RecommendSoftware:
        systemInstruction = INSTRUCTIONS.systemInstructionMain;
        break;
      case ChatCommand.BenchmarkCompanies:
        systemInstruction = INSTRUCTIONS.systemInstructionMain;
        break;
      case ChatCommand.GeneralMode:
        systemInstruction = INSTRUCTIONS.systemInstructionMain;
        break;

      default:
        systemInstruction = INSTRUCTIONS.systemInstructionMain;
    }

    const requestDto: RequestDto = {
      config: {
        systemInstruction: systemInstruction,
        temperature: 0.7,
      },
      contents : [{
        role: RoleEnum.USER,
        parts: [message]
      }]
    }

    // this.proxyService.proxyRequest({body:requestDto}).subscribe((response) => {
    //   console.log(response);
    // });

    this.proxyService.proxyRequest({ body: requestDto }).subscribe(async (response: Blob) => {
      const reader = response.stream().getReader();
      const decoder = new TextDecoder('utf-8');

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunkText = decoder.decode(value, { stream: true });
        console.log(chunkText); // Выводим каждую часть сразу

      }
    });

  }

   private setupMarkedRenderer(): void {
      const renderer = new marked.Renderer();

      renderer.link = function({ href, title, tokens }: Tokens.Link): string {
        const text = marked.parser(tokens);

        // Проверка на внутреннюю или относительную ссылку
        const isInternal = href.startsWith('/') || !href.startsWith('http');

        if (isInternal) {
          // Экранируем кавычки, если нужно
          return `<a href="${href}" role="button" class="router-link">${text}</a>`;
        }

        // Внешние ссылки
        const titleAttr = title ? ` title="${title}"` : '';
        return `<a href="${href}"${titleAttr} target="_blank" role="button" rel="noopener noreferrer">${text}</a>`;
      };
      renderer.code = ({ text, lang }) => {
        if (lang === 'json') {
          try {
            const parsedJson = JSON.parse(text);
            const formattedJson = JSON.stringify(parsedJson, null, 2);
            return `
                    <details class="mt-2 mb-2">
                    <summary><b>Expand / Collapse JSON</b></summary>
                    <pre><code class="language-json">${formattedJson}</code></pre>
                    </details>`;
          } catch (e) {
            return `<pre><code>${text}</code></pre>`;
          }
        }
        return `${text}`;
      };
      marked.setOptions({ renderer });
    }
}
